(function(){
  var track = document.getElementById('rvTrack');
  if (!track) return;
  var prev = document.getElementById('rvPrev');
  var next = document.getElementById('rvNext');
  var dotsWrap = document.getElementById('rvDots');
  var cards = Array.prototype.slice.call(track.querySelectorAll('.rv-card'));
  var total = cards.length;
  if (!total) return;
  function step(){
    if (!cards[0]) return 280;
    var r = cards[0].getBoundingClientRect();
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '16') || 16;
    return r.width + gap;
  }
  if (prev) prev.addEventListener('click', function(){ track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function(){ track.scrollBy({ left: step(), behavior: 'smooth' }); });
  if (dotsWrap) {
    dotsWrap.innerHTML = '';
    for (var i = 0; i < total; i++) {
      var d = document.createElement('button');
      d.className = 'rv-dot' + (i === 0 ? ' active' : '');
      d.setAttribute('aria-label', 'Review ' + (i + 1));
      (function(idx){
        d.addEventListener('click', function(){
          if (cards[idx]) cards[idx].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        });
      })(i);
      dotsWrap.appendChild(d);
    }
    var dots = dotsWrap.querySelectorAll('.rv-dot');
    var ticking = false;
    function updateDots(){
      var idx = Math.round(track.scrollLeft / step());
      idx = Math.max(0, Math.min(total - 1, idx));
      for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('active', i === idx);
      ticking = false;
    }
    track.addEventListener('scroll', function(){
      if (!ticking) { window.requestAnimationFrame(updateDots); ticking = true; }
    }, { passive: true });
  }
})();
